import { useEffect, useRef, useState } from 'react';
import { useProperty } from '@eti/providers';
import type { UseFormWatch, UseFormSetValue } from 'react-hook-form';
import type { SearchFormValues } from '../../../../common/search-form-panel/SearchFormNewContainer';
import SearchResultsGraphqlContainer from './containers/SearchResultsGraphqlContainer';
import { useResultPageContext } from './contexts/ResultPageContext';
import ResultSearchDetails from './ResultSearchDetails';

const ResultPageContent = () => {
  const {
    isSearchLoading,
    savedTrips,
    searchData,
    selectedTripData,
    setSelectedTrip,
    setTripsDetails,
  } = useResultPageContext();
  const [isSavedTripDrawerOpen, setIsSavedTripDrawerOpen] = useState(false);
  const { p } = useProperty();
  const isSkeletonEnabled = p('Result.Skeleton.Enabled');

  if (savedTrips.length === 0 && isSavedTripDrawerOpen) {
    setIsSavedTripDrawerOpen(false);
  }
  useEffect(() => {
    if (searchData) {
      const { flights, sponsoredTrips } = searchData;
      const flightDetails = selectedTripData
        ? [...flights, selectedTripData, ...sponsoredTrips]
        : [...flights, ...sponsoredTrips];
      setTripsDetails(flightDetails);
    }
    setSelectedTrip(null);
    if (selectedTripData) {
      setSelectedTrip(selectedTripData);
    }
  }, [searchData, setSelectedTrip, setTripsDetails, selectedTripData]);
  const searchFormWatchRef = useRef<UseFormWatch<SearchFormValues> | null>(null);
  const setValueRef = useRef<UseFormSetValue<SearchFormValues> | null>(null);
  return (
    <>
      {((!isSearchLoading && !isSkeletonEnabled) || isSkeletonEnabled) && (
        <ResultSearchDetails searchFormWatchRef={searchFormWatchRef} setValueRef={setValueRef} />
      )}
      <SearchResultsGraphqlContainer
        searchFormWatchRef={searchFormWatchRef}
        setValueRef={setValueRef}
      />
    </>
  );
};

export default ResultPageContent;
